module.exports = __webpack_public_path__ + "img/172d0a9.png";